module.exports = __webpack_public_path__ + "static/media/6262.88bcdf64.jpg";